export const initProductMenu = (): void => {
  const mobileViewport = window.matchMedia("(max-width: 1200px)");
  const hoverPointer = window.matchMedia("(hover: hover)");

  // The vendor script creates desktop, sticky and mobile copies before this runs.
  document
    .querySelectorAll<HTMLElement>(".navigation > .product-menu")
    .forEach((menu, menuIndex) => {
      if (menu.dataset.productMenuReady) return;

      const rootToggle = menu.querySelector<HTMLButtonElement>(
        ":scope > .product-menu__toggle",
      );
      const rootLink = menu.querySelector<HTMLAnchorElement>(":scope > a");
      if (!rootToggle) return;

      const isMobile = Boolean(menu.closest(".mobile-menu"));
      const toggles = menu.querySelectorAll<HTMLButtonElement>(
        ".product-menu__toggle",
      );
      let closeTimer: ReturnType<typeof setTimeout> | undefined;

      const setOpen = (toggle: HTMLButtonElement, open: boolean): void => {
        if (open) clearTimeout(closeTimer);
        toggle.setAttribute("aria-expanded", String(open));
        toggle.parentElement?.classList.toggle("is-open", open);
      };

      const closeMenu = (): void => {
        clearTimeout(closeTimer);
        toggles.forEach((toggle) => setOpen(toggle, false));
      };

      toggles.forEach((toggle, toggleIndex) => {
        const panel = toggle.nextElementSibling;
        if (!(panel instanceof HTMLUListElement)) return;

        // Cloned menus need their own IDs for aria-controls.
        panel.id = `product-menu-panel-${menuIndex}-${toggleIndex}`;
        toggle.setAttribute("aria-controls", panel.id);
        toggle.addEventListener("click", () => {
          const open = toggle.getAttribute("aria-expanded") !== "true";
          if (toggle === rootToggle && !open) closeMenu();
          else setOpen(toggle, open);
        });
      });

      menu.dataset.productMenuReady = "true";

      menu.addEventListener("pointerenter", () => {
        clearTimeout(closeTimer);
        if (!isMobile && hoverPointer.matches) setOpen(rootToggle, true);
      });

      menu.addEventListener("pointerleave", () => {
        if (!isMobile && !menu.contains(document.activeElement)) {
          closeTimer = setTimeout(closeMenu, 150);
        }
      });

      menu.addEventListener("focusin", (event) => {
        if (!isMobile && event.target !== rootToggle) setOpen(rootToggle, true);
      });

      menu.addEventListener("focusout", (event) => {
        if (isMobile) return;
        // activeElement is temporarily body while focus moves between links.
        if (!menu.contains(event.relatedTarget as Node | null)) closeMenu();
      });

      menu.addEventListener("keydown", (event) => {
        if (event.key !== "Escape") return;
        event.preventDefault();
        (isMobile ? rootToggle : rootLink)?.focus();
        closeMenu();
      });

      document.addEventListener("click", (event) => {
        if (!menu.contains(event.target as Node)) closeMenu();
      });

      mobileViewport.addEventListener("change", closeMenu);
    });
};
